import React, { FocusEventHandler } from 'react';
import Select, { OptionTypeBase } from 'react-select';
import { ReactSelectHelper, ReactSelectOnChangeCallback } from './react-select-types';
import { SelectComponents } from 'react-select/src/components';

type getOptionValue<TOption> = (option: TOption) => string;
type getOptionLabel<TOption> = (option: TOption) => string;

type SingleSelectProps<TOption extends OptionTypeBase> = {
  options: readonly TOption[];
  value: TOption | null;
  getValue: getOptionValue<TOption>;
  getLabel: getOptionLabel<TOption>;
  onChange: (value: TOption | null) => void;
  onBlur?: () => void;
  isClearable?: boolean;
  className?: string;
  isSearchable?: boolean;
  components?: Partial<SelectComponents<TOption>>
};

export class SingleSelect<TOption extends { [index: string]: any }>
  extends React.Component<SingleSelectProps<TOption>> {

  constructor(props: Readonly<SingleSelectProps<TOption>>) {
    super(props);
    this.handleChange = ReactSelectHelper.nullableSingle(
      '',
      this.props.onChange
    );
  }

  handleChange: ReactSelectOnChangeCallback<TOption>;

  handleBlur: FocusEventHandler = () => {
    const onBlur = this.props.onBlur;
    if (typeof onBlur === 'function')
      onBlur();
  };

  render() {
    return (
      <Select<TOption> options={this.props.options}
        getOptionValue={this.props.getValue}
        getOptionLabel={this.props.getLabel}
        value={this.props.value}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        isClearable={this.props.isClearable ?? true}
        className={this.props.className}
        isSearchable={this.props.isSearchable ?? true}
        components={this.props.components}
      >
      </Select>);
  }
}
